import { RowTypeKey, RowTypeMap, ToDoRowModel } from '../entities/Entities';
import antragRenderer from './antragRenderer';
import arbeitszeitRenderer from './arbeitszeitRenderer';
import konfliktRenderer from './konfliktRenderer';

export type CellRenderers<T extends ToDoRowModel> = {
  name: (row: T) => React.ReactNode;
  arbeitsbereich: (row: T) => React.ReactNode;
  arbeitszeit: (row: T) => React.ReactNode;
  dauer: (row: T) => React.ReactNode;
  hinweise: (row: T) => React.ReactNode;
  action: (row: T) => React.ReactNode;
};

export const renderRegistry = new Map<
  RowTypeKey,
  CellRenderers<ToDoRowModel>
>();

export function registerRenderer<K extends RowTypeKey>(
  type: K,
  renderer: CellRenderers<RowTypeMap[K]>,
) {
  renderRegistry.set(type, renderer as CellRenderers<ToDoRowModel>);
}

const defaultRenderer: CellRenderers<ToDoRowModel> = {
  name: () => <span>Default Name</span>,
  arbeitsbereich: () => <span>Default Arbeitsbereich</span>,
  arbeitszeit: () => <span>Default Arbeitszeit</span>,
  dauer: () => <span>Default Dauer</span>,
  hinweise: () => <span>Default Hinweise</span>,
  action: () => <span>Default Action</span>,
};
export function getRenderer<K extends RowTypeKey>(
  key: K,
): CellRenderers<RowTypeMap[K]> {
  return renderRegistry.get(key) ?? defaultRenderer;
}

registerRenderer('konflikt', konfliktRenderer);
registerRenderer('arbeitszeit', arbeitszeitRenderer);
registerRenderer('antrag', antragRenderer);
